import { JAB } from '../cards/attack/jab';
import { BULWARK } from '../cards/defense/bulwark';
import { SHIELD_UP } from '../cards/defense/shield-up';
import type { EnemyTemplate } from './template';

/** HEX-23 archetype ported (ADR-0015 §4, §15). Rare tier: 3×3 grid, 3 dice,
 * defence-leaning mix of common + rare. */
export const TOWER_SHIELD_GUARD: EnemyTemplate = {
  id: 'tower-shield-guard',
  name: 'Tower Shield Guard',
  glyph: '♜', // rook — the immovable tower guard
  tier: 'rare',
  hp: 26,
  loadout: [
    { card: BULWARK, origin: { row: 0, col: 0 }, rotated: false },
    { card: SHIELD_UP, origin: { row: 0, col: 2 }, rotated: false },
    { card: JAB, origin: { row: 2, col: 0 }, rotated: false },
  ],
  drops: { gold: 12 },
};
